import { NavLink, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BrandMark, SpectrumBar } from "@/components/BrandMark";

const linkCls = ({ isActive }) =>
  `px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
    isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"
  }`;

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200">
      <SpectrumBar className="h-1" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <NavLink to="/" data-testid="header-home-link"><BrandMark compact /></NavLink>
        <nav className="flex items-center gap-1 overflow-x-auto">
          <NavLink to="/" end className={linkCls} data-testid="nav-store-link">Store</NavLink>
          <NavLink to="/my-order" className={linkCls} data-testid="nav-my-order-link">My order</NavLink>
          {user?.role === "admin" && (
            <NavLink to="/admin" className={linkCls} data-testid="nav-admin-link">Admin</NavLink>
          )}
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden md:block text-sm text-slate-500 truncate max-w-[220px]" data-testid="header-user-email">
            {user?.email}
          </span>
          <button
            onClick={onLogout}
            data-testid="logout-btn"
            className="p-2 rounded-full text-slate-600 hover:bg-slate-100 transition-colors"
            aria-label="Log out"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </header>
  );
};
